const lang = {
  title_pages: process.env.MIX_APP_NAME,
  sent_code: '二段階認証コードをメールでお送りしました',
  enter_code: 'メールに記載されたコードを入力してください。',
  placeholder: '二段階認証コード',
  sent_new_code: 'コードが誤っております。（{nthTime}回目）<br>新しいコードがメールで送信されました。',
  notice:
    '※コードを間違えた場合、新しいコードがメールで送信されます。<br>※{numberOfTrial}回以上コードを間違えた場合アカウントがロックされます。',
  btn_back_login: 'ログイン画面に戻る',
  btn_submit: '入力',
}

export default lang
